import React from 'react';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

function Footer() {
  const { t } = useTranslation();

  return (
    <footer id="footer">
      <div>
        <span>
          <Link to="/help-page" className="mainColor">
            {t('Aide')}
          </Link>
        </span>
        <span>
          <Link to="/data" className="mainColor">
            {t('Charte de protéction des données')}
          </Link>
        </span>
      </div>
    </footer>
  );
}

export default Footer;